import React from "react";

import { Container, Typography, Paper } from "@mui/material";

function TermsConditionweb() {
  return (
    <Container>
      <Paper
        elevation={0}
        style={{ padding: "10px", marginTop: "20px", marginBottom: "20px" }}
      >
        <Typography
          variant="h2"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mb: 3,
            textAlign: "left",
          }}
        >
          Terms & Conditions – Yubai
        </Typography>

        <Typography variant="body2"
          paragraph
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px" }, lineHeight: "20px", fontFamily: "fangsong",color:"#666666"}}>
          Welcome to Yubai! These Terms & Conditions (“Terms”) govern your use
          of the Yubai website and mobile application (collectively referred to
          as the “Platform”) operated by Yubai L.L.C-FZ, a limited liability
          company registered in the Meydan Free Zone, Dubai, United Arab
          Emirates.
        </Typography>

        <Typography
          variant="body2"
          paragraph
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px" }, lineHeight: "20px",color:"#666666" , fontFamily: "fangsong","& p": { margin: 0 },}}
        >
          <p> Company Name: Yubai L.L.C-FZ</p>
          <p>Legal Form: Limited Liability Company – Free Zone</p>
          <p>
            Address: Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba,
            Dubai, U.A.E.
          </p>
          <p>
            Jurisdiction: Meydan Free Zone Regulations, Dubai, United Arab
            Emirates
          </p>

          <p>Official Contact: WhatsApp – [+971582584444]</p>
        </Typography>



        <Typography
          variant="h3"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "30px" },
            textAlign: "left",
          }}
        >
          1. Acceptance of Terms
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px"}, lineHeight: "20px", fontFamily: "fangsong"  }}
        >
          By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services.
        </Typography>

        <Typography
          variant="h3"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "30px" },
            textAlign: "left",
          }}
        >
          2. User Registration
        </Typography>


        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px"}, lineHeight: "20px", fontFamily: "fangsong"  }}
        >
          To access certain features of the Platform, you must register and create an account. You are responsible for maintaining the confidentiality of your login credentials and all activities that occur under your account.
        </Typography>

        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "30px" },
            textAlign: "left",
          }}
        >
          3. Eligibility
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px"}, lineHeight: "20px", fontFamily: "fangsong"  }}
        >
          Use of the Platform is permitted only for individuals who can form legally binding contracts under applicable law. Minors under 18 may use the platform only with the involvement of a parent or guardian.
        </Typography>

        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "30px" },
            textAlign: "left",
          }}
        >
          4. Information Collection
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px"}, lineHeight: "20px", fontFamily: "fangsong"  }}
        >
          We collect personal information including your name, phone number, email address, and shipping details in order to process
          your orders and improve our services. Please refer to our Privacy Policy for more details.
        </Typography>

        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "30px" },
            textAlign: "left",
          }}
        >
          5. International Orders
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px"}, lineHeight: "20px", fontFamily: "fangsong"  }}
        >
          Yubai accepts international orders and works with third-party shipping providers to fulfill deliveries. Please note that international shipping fees, customs duties, and taxes may apply and are the responsibility of the customer unless otherwise stated.
        </Typography>

        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "30px" },
            textAlign: "left",
          }}
        >
          6. Limitation of Liability
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px"}, lineHeight: "20px", fontFamily: "fangsong"  }}
        >
          To the fullest extent permitted by applicable law, Yubai disclaims all warranties and shall not be liable for any indirect, incidental, or consequential damages arising from the use of or inability to use the Platform.
        </Typography>

        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "30px" },
            textAlign: "left",
          }}
        >
          7. Changes to Terms
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px", lineHeight: "20px", fontFamily: "fangsong" } }}
        >
          We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting on the Platform. Your continued use of the Platform following the posting of revised Terms means you accept and agree to the changes.
        </Typography>

        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontSize: { xs: "19px", sm: "32px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "30px" },
            textAlign: "left",
          }}
        >
          8. Governing Law
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textAlign: "left", fontSize: { xs: "13px", sm: "16px", lineHeight: "20px", fontFamily: "fangsong" } }}
        >
          These Terms shall be governed by and construed in accordance with the laws and regulations of the Meydan Free Zone, Dubai, United Arab Emirates.
        </Typography>

      </Paper>
    </Container>
  );
}

export default TermsConditionweb;
